import { NavLink } from 'react-router-dom'

/** Leads and Disputes: two views of the same leads. */
export function LeadsTabs() {
  return (
    <nav className="page-tabs" aria-label="Leads">
      <NavLink to="/portal/leads" end className={({ isActive }) => (isActive ? 'page-tab is-on' : 'page-tab')}>All leads</NavLink>
      <NavLink to="/portal/disputes" className={({ isActive }) => (isActive ? 'page-tab is-on' : 'page-tab')}>Disputes</NavLink>
    </nav>
  )
}
